import { Pipe, PipeTransform } from '@angular/core';
import { Language, LanguageService } from '../services/language-service.service';
import { Difficulty } from '../services/question.service';

@Pipe({
  name: 'ariaTranslate'
})
export class AriaTranslatePipe implements PipeTransform {

  constructor(private languageService: LanguageService) {}


  // NOTE: The language parameter is not required, but it is passed to force change detection
  transform(value: any, language: Language, isGameLabel: boolean = false): string {

    if (isGameLabel) {
      if (this.languageService.learnDifficulty !== Difficulty.Easy) {
        return value.content[Difficulty.Easy][language];
      }
      else {
        return value.content[Difficulty.Medium][language];
      }
    }
    else {
      if (!!language) {
        return this.languageService.AriaTexts[value][language];
      }
      else {
        return this.languageService.AriaTexts[value].fi;
      }
    }
  }

}
